import {postRequest} from "../api";

export const publish = payload => {
  payload.metric = 0;
  return postRequest(`/iroh/telemetry/publish`, [payload], {timeout: 500});
};
